import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import { Shield, Mail, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import { API_URL } from '../config';
import '../styles/Auth.css';


const RequestAccess = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('loading');
    
    try {
      await axios.post(`${API_URL}/api/auth/request-access`, null, {
        params: { email }
      });
      setStatus('success');
    } catch (err) {
      console.error('Request access failed:', err);
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <>
        <Header />
        <div className="auth-page request-access-page">
          <div className="auth-container">
            <div className="auth-logo-container">
              <Shield size={40} />
              <span>All Secured</span>
            </div>
            
            <div className="auth-status-container success">
              <CheckCircle size={48} className="success-icon" />
              <h2>Check Your Email</h2>
              <p>
                If an account exists with <strong>{email}</strong>, you'll receive an access link shortly.
              </p>
              <p className="auth-note" style={{marginTop: '12px'}}>
                <strong>Gmail users:</strong> Check your <strong>"All Mail"</strong> folder and <strong>"Spam"</strong> folder if you don't see the email in your Inbox.
              </p>
              <div className="auth-actions">
                <Link to="/login" className="auth-secondary-btn">
                  Go to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="auth-page request-access-page">
        <div className="auth-container">
          <div className="auth-logo-container">
            <Shield size={40} />
            <span>All Secured</span>
          </div>
          
          <div className="auth-form-container">
            <div className="auth-header">
              <Mail size={32} className="auth-icon" />
              <h2>Request Access Link</h2>
              <p>Enter your email to receive a new access link for your course.</p>
            </div>
            
            <form onSubmit={handleSubmit} className="auth-form">
              {error && (
                <div className="auth-error">
                  <AlertCircle size={16} />
                  <span>{error}</span>
                </div>
              )}
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  data-testid="email-input"
                />
              </div>
              
              <button 
                type="submit" 
                className="auth-submit-btn"
                disabled={status === 'loading'}
                data-testid="request-access-btn"
              >
                {status === 'loading' ? (
                  <>
                    <Loader2 className="btn-spinner" size={18} />
                    Sending...
                  </>
                ) : (
                  'Send Access Link'
                )}
              </button>
            </form>
            
            <div className="auth-footer">
              <p>
                Remember your password?{' '}
                <Link to="/login" className="auth-link">
                  Sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestAccess;
